import { Flex } from '@chakra-ui/react';
import { useSelectCompetenciesSelectedGroupBy } from 'Deer/intent/Competencies/slice/CompetenciesIntentSlice';
import { useSelectedView } from 'reducers/viewsSlice';
import { Loader } from 'screens/analytics/commonComponents';
import { checkIntentLandingPagesFeatureEnabled } from 'utils/helpers/featureFlags';

import { PaperWithShadow } from 'uiToolkitV1/Paper';

import { useLevelUpAnalytics } from '../context';
import CFbarChart from './CFbarChart';
import { useCFBarGraphData } from './hooks/dataHooks';

function CFbarChartSection() {
  const {
    state: { currentState },
  } = useLevelUpAnalytics();
  const { selectedGroupByKey, selectedSplitByKey, selectedDateRange } = currentState;

  const sideNavSelectedCohort = useSelectedView();

  const selectedGroupByValue = useSelectCompetenciesSelectedGroupBy(sideNavSelectedCohort?.id);

  const groupBy = checkIntentLandingPagesFeatureEnabled() ? selectedGroupByValue : selectedGroupByKey;

  const { data, isLoading } = useCFBarGraphData({
    cohort: sideNavSelectedCohort,
    groupByKeys: groupBy,
    splitByKeys: {
      uuid: null,
      keyName: 'none',
      displayName: 'None',
      enabled: true,
    },
    dateRange: selectedDateRange,
  });
  if (isLoading) {
    <Loader />;
  }

  if (data) {
    return (
      <Flex gap={4} marginBottom={3}>
        <PaperWithShadow p={4} flexBasis="100%" w="100%">
          <CFbarChart chartData={data?.data} isLoading={isLoading} />
        </PaperWithShadow>
      </Flex>
    );
  }

  return null;
}

export default CFbarChartSection;
